export { PrispevkyModule } from './prispevky.module';
export { ClassicPrispevkyComponent } from './classic/classic-prispevky.component';
export { ImagePrispevkyComponent } from './image/image-prispevky.component';
